import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ContractType = "employee" | "manager" | null;

export interface ContractGateState {
  isGateOpen: boolean;
  contractType: ContractType;
  requiredContracts: string[];
  contractVersion: number | null;
  companyName: string | null;
  lastOpenedAt: number | null;
}

const initialState: ContractGateState = {
  isGateOpen: false,
  contractType: null,
  requiredContracts: [],
  contractVersion: null,
  companyName: null,
  lastOpenedAt: null,
};

const contractSlice = createSlice({
  name: "contractGate",
  initialState,
  reducers: {
    openContractGate: (
      state,
      action: PayloadAction<{
        contractType?: ContractType;
        requiredContracts: string[];
        contractVersion?: number | null;
        companyName?: string | null;
      }>
    ) => {
      state.isGateOpen = action.payload.requiredContracts?.length > 0;
      state.contractType = action.payload.contractType ?? null;
      state.requiredContracts = action.payload.requiredContracts ?? [];
      state.contractVersion = action.payload.contractVersion ?? null;
      state.companyName = action.payload.companyName ?? null;
      state.lastOpenedAt = Date.now();
    },
    closeContractGate: (state) => {
      state.isGateOpen = false;
      state.requiredContracts = [];
      state.contractType = null;
      state.contractVersion = null;
      state.companyName = null;
      state.lastOpenedAt = null;
    },
  },
});

export const { openContractGate, closeContractGate } = contractSlice.actions;
export default contractSlice.reducer;

